import { FC } from "react";
import { useSelector } from "react-redux";

import { MoreHoriz } from "@livechat/design-system-icons";
import { ActionMenu, ActionMenuItem, Button, DesignToken, Icon, Text } from "@livechat/design-system-react-components";

import { DEFAULT_ADDRESS_ID } from "constants/settings/replyAddresses";
import { selectIsAdmin } from "store/entities/agents";
import { IReplyAddress } from "store/entities/reply-addresses/interfaces";
import { withVar } from "themes/helpers";

import { trackDeleteAddressModalOpened, trackEditModalOpened, trackPreviewAddressModalOpened } from "../analytics";
import { ShowDeleteModal, ShowEditModal, ShowPreviewModal } from "../interfaces";

interface IProps {
  fromName: string | null;
  replyAddress: IReplyAddress;
  showPreviewModal: ShowPreviewModal;
  showDeleteModal: ShowDeleteModal;
  showEditModal: ShowEditModal;
}
export const ReplyAddressActionMenu: FC<IProps> = ({
  fromName,
  replyAddress: { id, email, verified },
  showPreviewModal,
  showDeleteModal,
  showEditModal,
}) => {
  const isAdmin = useSelector(selectIsAdmin);

  const isDefaultAddress = id === DEFAULT_ADDRESS_ID;
  const isReplyAddressDeletable = !isAdmin || (isDefaultAddress && fromName === null);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleEdit = () => {
    if (!isDefaultAddress) {
      showEditModal({ id, fromName, isEdit: true });
    } else {
      showEditModal({ fromName, isEdit: true });
    }
    trackEditModalOpened(isDefaultAddress, isDefaultAddress ? undefined : id, fromName ?? undefined);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handlePreview = () => {
    trackPreviewAddressModalOpened(email, fromName ?? undefined);
    showPreviewModal({ fromName, email: email, verified: verified });
  };
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleDelete = () => {
    trackDeleteAddressModalOpened(isDefaultAddress, isDefaultAddress ? undefined : id, fromName ?? undefined);
    showDeleteModal({ id, fromName });
  };
  return (
    <ActionMenu
      triggerRenderer={<Button kind="plain" icon={<Icon source={MoreHoriz} />} />}
      options={[
        {
          key: "edit",
          element: <ActionMenuItem>Edit</ActionMenuItem>,
          onClick: handleEdit,
          disabled: !isAdmin,
        },
        {
          key: "preview",
          element: <ActionMenuItem>Preview</ActionMenuItem>,
          onClick: handlePreview,
        },
        {
          key: "delete",
          element: (
            <ActionMenuItem kind="warning">
              <Text
                customColor={withVar(
                  isReplyAddressDeletable ? DesignToken.ActionNegativeDisabled : DesignToken.ActionNegativeDefault
                )}
              >
                Delete
              </Text>
            </ActionMenuItem>
          ),
          onClick: handleDelete,
          disabled: isReplyAddressDeletable,
        },
      ]}
    />
  );
};
